import { render, staticRenderFns } from "./CheckoutsList.vue?vue&type=template&id=38d83d61&scoped=true&"
import script from "./CheckoutsList.vue?vue&type=script&lang=js&"
export * from "./CheckoutsList.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutsList.vue?vue&type=style&index=0&id=38d83d61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d83d61",
  null
  
)

export default component.exports